<template>
  <div>
    <!-- Profile -->
    <div v-if="log.log_type === 'contact' && log.type === 'created' && model_log === 'Profile'" class="record">
      <div v-if="log.new_values.job_title !== null" class="row">
        <div class="col-5"><strong>Job Title</strong></div>
        <div class="col-7">{{ log.new_values.job_title }}</div>
      </div>
      <div v-if="log.new_values.title !== null" class="row">
        <div class="col-5"><strong>Title</strong></div>
        <div class="col-7">{{ log.new_values.title }}</div>
      </div>
      <div v-if="log.new_values.first_name !== null" class="row">
        <div class="col-5"><strong>First Name</strong></div>
        <div class="col-7">{{ log.new_values.first_name }}</div>
      </div>
      <div v-if="log.new_values.surname !== null" class="row">
        <div class="col-5"><strong>Surname</strong></div>
        <div class="col-7">{{ log.new_values.surname }}</div>
      </div>
      <div v-if="log.new_values.phone !== null" class="row">
        <div class="col-5"><strong>Landline Number</strong></div>
        <div class="col-7">{{ log.new_values.phone }}</div>
      </div>
      <div v-if="log.new_values.mobile !== null" class="row">
        <div class="col-5"><strong>Mobile</strong></div>
        <div class="col-7">{{ log.new_values.mobile }}</div>
      </div>
      <div v-if="log.new_values.email !== null" class="row">
        <div class="col-5"><strong>Email</strong></div>
        <div class="col-7">{{ log.new_values.email }}</div>
      </div>
      <div v-if="log.new_values.address_same_as_client !== null" class="row">
        <div class="col-5"><strong>Address same as client</strong></div>
        <div class="col-7">
          <span v-if="log.new_values.address_same_as_client">Yes</span>
          <span v-if="!log.new_values.address_same_as_client">No</span>
        </div>
      </div>
      <div v-if="log.new_values.address !== null" class="row">
        <div class="col-5"><strong>Address</strong></div>
        <div class="col-7">{{ log.new_values.address }}</div>
      </div>
    </div>
    <div v-if="(log.type === 'restored' || log.type === 'updated') && model_log === 'Profile'" class="record">
      <div v-if="log.new_values !== null && 'job_title' in log.new_values" class="row">
        <div class="col-5"><strong>Job Title</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ log.new_values.job_title }}</div>
          <div class="old_value">{{ log.old_values.job_title }}</div>
        </div>
      </div>
      <div v-if="log.new_values !== null && 'title' in log.new_values" class="row">
        <div class="col-5"><strong>Title</strong></div>
        <div class="col-7">
          <div class="updated_at">{{ log.new_values.title }}</div>
          <div class="old_value">{{ log.old_values.title }}</div>
        </div>
      </div>
      <div v-if="log.new_values !== null && 'first_name' in log.new_values" class="row">
        <div class="col-5"><strong>First Name</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ log.new_values.first_name }}</div>
          <div class="old_value">{{ log.old_values.first_name }}</div>
        </div>
      </div>
      <div v-if="log.new_values !== null && 'surname' in log.new_values" class="row">
        <div class="col-5"><strong>Surname</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ log.new_values.surname }}</div>
          <div class="old_value">{{ log.old_values.surname }}</div>
        </div>
      </div>
      <div v-if="log.new_values !== null && 'phone' in log.new_values" class="row">
        <div class="col-5"><strong>Landline Number</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ log.new_values.phone }}</div>
          <div class="old_value">{{ log.old_values.phone }}</div>
        </div>
      </div>
      <div v-if="log.new_values !== null && 'mobile' in log.new_values" class="row">
        <div class="col-5"><strong>Mobile</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ log.new_values.mobile }}</div>
          <div class="old_value">{{ log.old_values.mobile }}</div>
        </div>
      </div>
      <div v-if="log.new_values !== null && 'email' in log.new_values" class="row">
        <div class="col-5"><strong>Email</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ log.new_values.email }}</div>
          <div class="old_value">{{ log.old_values.email }}</div>
        </div>
      </div>
      <div v-if="log.new_values !== null && 'address_same_as_client' in log.new_values" class="row">
        <div class="col-5"><strong>Address same as client</strong></div>
        <div class="col-7">
          <div class="updated_value">
            <span v-if="log.new_values.address_same_as_client">Yes</span>
            <span v-else-if="!log.new_values.address_same_as_client">No</span>
          </div>
          <div class="old_value">
            <span v-if="log.old_values.address_same_as_client">Yes</span>
            <span v-else-if="!log.old_values.address_same_as_client">No</span>
          </div>
        </div>
      </div>
      <div v-if="log.new_values !== null && 'address' in log.new_values" class="row">
        <div class="col-5"><strong>Address</strong></div>
        <div class="col-7">
          <div class="updated_value">{{ log.new_values.address }}</div>
          <div class="old_value">{{ log.old_values.address }}</div>
        </div>
      </div>
    </div>
    <div v-if="(log.type === 'deleted') && model_log === 'Profile'" class="record">
      <div v-if="log.old_values !== null && 'job_title' in log.old_values" class="row">
        <div class="col-5"><strong>Job Title</strong></div>
        <div class="col-7">
          <div class="old_value">{{ log.old_values.job_title }}</div>
        </div>
      </div>
      <div v-if="log.old_values !== null && 'title' in log.old_values" class="row">
        <div class="col-5"><strong>Title</strong></div>
        <div class="col-7">
          <div class="old_value">{{ log.old_values.title }}</div>
        </div>
      </div>
      <div v-if="log.old_values !== null && 'first_name' in log.old_values" class="row">
        <div class="col-5"><strong>First Name</strong></div>
        <div class="col-7">
          <div class="old_value">{{ log.old_values.first_name }}</div>
        </div>
      </div>
      <div v-if="log.old_values !== null && 'surname' in log.old_values" class="row">
        <div class="col-5"><strong>Surname</strong></div>
        <div class="col-7">
          <div class="old_value">{{ log.old_values.surname }}</div>
        </div>
      </div>
      <div v-if="log.old_values !== null && 'phone' in log.old_values" class="row">
        <div class="col-5"><strong>Landline Number</strong></div>
        <div class="col-7">
          <div class="old_value">{{ log.old_values.phone }}</div>
        </div>
      </div>
      <div v-if="log.old_values !== null && 'mobile' in log.old_values" class="row">
        <div class="col-5"><strong>Mobile</strong></div>
        <div class="col-7">
          <div class="old_value">{{ log.old_values.mobile }}</div>
        </div>
      </div>
      <div v-if="log.old_values !== null && 'email' in log.old_values" class="row">
        <div class="col-5"><strong>Email</strong></div>
        <div class="col-7">
          <div class="old_value">{{ log.old_values.email }}</div>
        </div>
      </div>
      <div v-if="log.old_values !== null && 'address_same_as_client' in log.old_values" class="row">
        <div class="col-5"><strong>Address same as client</strong></div>
        <div class="col-7">
          <div class="old_value">
            <span v-if="log.old_values.address_same_as_client">Yes</span>
            <span v-else-if="!log.old_values.address_same_as_client">No</span>
          </div>
        </div>
      </div>
      <div v-if="log.old_values !== null && 'address' in log.old_values" class="row">
        <div class="col-5"><strong>Address</strong></div>
        <div class="col-7">
          <div class="old_value">{{ log.old_values.address }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "contact",
  props: {log: null, model_log: null},
}
</script>
